import migrateToV3_0_0 from "./to/v3.0.0.js";
import migrateToV3_1_0 from "./to/v3.1.0.js";
import migrateToV3_3_0 from "./to/v3.3.0.js";
import migrateToV3_9_0 from "./to/v3.9.0.js";
import migrateToV3_10_0 from "./to/v3.10.0.js";
import migrateToV3_11_0 from "./to/v3.11.0.js";
import migrateToV3_12_3 from "./to/v3.12.3.js";
import migrateToV3_13_0 from "./to/v3.13.0.js";
import migrateToV3_17_0 from "./to/v3.17.0.js";
import migrateToV3_18_0 from "./to/v3.18.0.js";
import migrateToV3_18_1 from "./to/v3.18.1.js";
import migrateToV3_18_2 from "./to/v3.18.2.js";
import migrateToV3_20_0 from "./to/v3.20.0.js";
import migrateToV3_22_0 from "./to/v3.22.0.js";
import migrateToV3_24_0 from "./to/v3.24.0.js";
import migrateToV3_25_0 from "./to/v3.25.0.js";
import migrateToV3_31_0 from "./to/v3.31.0.js";
import migrateToV3_32_0 from "./to/v3.32.0.js";
import migrateToV3_34_0 from "./to/v3.34.0.js";
import migrateToV3_36_0 from "./to/v3.36.0.js";
import migrateToV3_39_0 from "./to/v3.39.0.js";
import migrateToV3_40_0 from "./to/v3.40.0.js";
import migrateToV3_46_0 from "./to/v3.46.0.js";
import migrateToV3_57_0 from "./to/v3.57.0.js";
import migrateToV3_60_0 from "./to/v3.60.0.js";
function getNoopMigration(_from, to) {
    return async (_context, projectSchema) => {
        return {
            ...projectSchema,
            schemaVersion: to
        };
    };
}
export const migrateTo = {
    'v3.0.0': migrateToV3_0_0,
    'v3.1.0': migrateToV3_1_0,
    'v3.2.0': getNoopMigration('3.1.0', '3.2.0'),
    'v3.3.0': migrateToV3_3_0,
    'v3.4.0': getNoopMigration('3.3.0', '3.4.0'),
    'v3.5.0': getNoopMigration('3.4.0', '3.5.0'),
    'v3.5.1': getNoopMigration('3.5.0', '3.5.1'),
    'v3.6.0': getNoopMigration('3.5.1', '3.6.0'),
    'v3.7.0': getNoopMigration('3.6.0', '3.7.0'),
    'v3.8.0': getNoopMigration('3.7.0', '3.8.0'),
    'v3.9.0': migrateToV3_9_0,
    'v3.10.0': migrateToV3_10_0,
    'v3.11.0': migrateToV3_11_0,
    'v3.12.0': getNoopMigration('3.11.0', '3.12.0'),
    'v3.12.1': getNoopMigration('3.12.0', '3.12.1'),
    'v3.12.2': getNoopMigration('3.12.1', '3.12.2'),
    'v3.12.3': migrateToV3_12_3,
    'v3.13.0': migrateToV3_13_0,
    'v3.14.0': getNoopMigration('3.13.0', '3.14.0'),
    'v3.15.0': getNoopMigration('3.14.0', '3.15.0'),
    'v3.16.0': getNoopMigration('3.15.0', '3.16.0'),
    'v3.17.0': migrateToV3_17_0,
    'v3.17.1': getNoopMigration('3.17.0', '3.17.1'),
    'v3.18.0': migrateToV3_18_0,
    'v3.18.1': migrateToV3_18_1,
    'v3.18.2': migrateToV3_18_2,
    'v3.19.0': getNoopMigration('3.18.2', '3.19.0'),
    'v3.20.0': migrateToV3_20_0,
    'v3.21.0': getNoopMigration('3.20.0', '3.21.0'),
    'v3.22.0': migrateToV3_22_0,
    'v3.23.0': getNoopMigration('3.22.0', '3.23.0'),
    'v3.24.0': migrateToV3_24_0,
    'v3.25.0': migrateToV3_25_0,
    'v3.26.0': getNoopMigration('3.25.0', '3.26.0'),
    'v3.27.0': getNoopMigration('3.26.0', '3.27.0'),
    'v3.28.0': getNoopMigration('3.27.0', '3.28.0'),
    'v3.29.0': getNoopMigration('3.28.0', '3.29.0'),
    'v3.30.0': getNoopMigration('3.29.0', '3.30.0'),
    'v3.31.0': migrateToV3_31_0,
    'v3.32.0': migrateToV3_32_0,
    'v3.33.0': getNoopMigration('3.32.0', '3.33.0'),
    'v3.34.0': migrateToV3_34_0,
    'v3.35.0': getNoopMigration('3.34.0', '3.35.0'),
    'v3.36.0': migrateToV3_36_0,
    'v3.37.0': getNoopMigration('3.36.0', '3.37.0'),
    'v3.38.0': getNoopMigration('3.37.0', '3.38.0'),
    'v3.39.0': migrateToV3_39_0,
    'v3.40.0': migrateToV3_40_0,
    'v3.41.0': getNoopMigration('3.40.0', '3.41.0'),
    'v3.42.0': getNoopMigration('3.41.0', '3.42.0'),
    'v3.43.0': getNoopMigration('3.42.0', '3.43.0'),
    'v3.44.0': getNoopMigration('3.43.0', '3.44.0'),
    'v3.45.0': getNoopMigration('3.44.0', '3.45.0'),
    'v3.46.0': migrateToV3_46_0,
    'v3.47.0': getNoopMigration('3.46.0', '3.47.0'),
    'v3.48.0': getNoopMigration('3.47.0', '3.48.0'),
    'v3.49.0': getNoopMigration('3.48.0', '3.49.0'),
    'v3.50.0': getNoopMigration('3.49.0', '3.50.0'),
    'v3.51.0': getNoopMigration('3.50.0', '3.51.0'),
    'v3.52.0': getNoopMigration('3.51.0', '3.52.0'),
    'v3.53.0': getNoopMigration('3.52.0', '3.53.0'),
    'v3.54.0': getNoopMigration('3.53.0', '3.54.0'),
    'v3.55.0': getNoopMigration('3.54.0', '3.55.0'),
    'v3.56.0': getNoopMigration('3.55.0', '3.56.0'),
    'v3.57.0': migrateToV3_57_0,
    'v3.58.0': getNoopMigration('3.57.0', '3.58.0'),
    'v3.59.0': getNoopMigration('3.58.0', '3.59.0'),
    'v3.60.0': migrateToV3_60_0,
    'v3.61.0': getNoopMigration('3.60.0', '3.61.0'),
    'v3.62.0': getNoopMigration('3.61.0', '3.62.0'),
    'v3.63.0': getNoopMigration('3.62.0', '3.63.0')
};
export * from "./utils.js";
export const listTypePrefix = 'PaginatedList';
